import React from 'react';
import SwachhBharat2023 from 'views/SwachhBharat2023';

const AccountGeneralPage = () => {
  return <SwachhBharat2023/>;
};

export default AccountGeneralPage;